import { __decorate, __metadata } from "tslib";
import { lazyAppContextConsumer } from '@1inch-community/core/lazy';
import { subscribe } from '@1inch-community/core/lit-utils';
import { BigFloat } from '@1inch-community/core/math';
import '@1inch-community/ui-components/loaders';
import '@1inch-community/ui-components/number-animation';
import { Task } from '@lit/task';
import { html, LitElement } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';
import { tap } from 'rxjs';
import { tooltip } from '../../tooltip';
import { tokenBalanceStyle } from '../style/token-balance.style';
let TokenBalanceElement = class TokenBalanceElement extends LitElement {
    constructor() {
        super(...arguments);
        this.endTextAlign = false;
        this.animateTransition = true;
        this.skeletonAnimationDelayMillisecond = 0;
        this.isConnectedWallet = true;
        this.applicationContext = lazyAppContextConsumer(this);
        this.task = new Task(this, async ([tokenId, symbol, chainIds, walletAddress]) => {
            if (this.value) {
                return this.value;
            }
            if (!this.isConnectedWallet) {
                return BigFloat.zero();
            }
            if (tokenId && walletAddress) {
                return await this.applicationContext.value.tokenStorage.getTokenBalanceById({
                    tokenRecordId: tokenId,
                    walletAddress,
                });
            }
            if (symbol && chainIds && walletAddress) {
                return await this.applicationContext.value.tokenStorage.getTotalTokenBalanceBySymbol({
                    chainIds,
                    symbol,
                    walletAddress,
                });
            }
            throw new Error('');
        }, () => [this.tokenId, this.symbol, this.chainIds, this.walletAddress]);
    }
    static { this.tagName = 'inch-token-balance'; }
    static { this.styles = tokenBalanceStyle; }
    firstUpdated() {
        if (this.value) {
            return;
        }
        subscribe(this, [
            this.applicationContext.value.onChain.crossChainEmitter.pipe(tap(() => this.task.run([this.tokenId, this.symbol, this.chainIds, this.walletAddress]))),
            this.applicationContext.value.wallet.data.isConnected$.pipe(tap((state) => (this.isConnectedWallet = state))),
        ], { requestUpdate: false });
    }
    render() {
        return this.task.render({
            error: () => this.renderBalanceOrLoader(),
            pending: () => this.renderBalanceOrLoader(),
            complete: () => this.renderBalanceOrLoader(),
        });
    }
    renderBalanceOrLoader() {
        if (!this.task.value)
            return this.renderLoader();
        return this.renderBalance(this.task.value);
    }
    renderBalance(balance) {
        if (this.animateTransition) {
            const style = {
                justifyContent: this.endTextAlign ? 'end' : '',
            };
            return html `
        <inch-number-animation
          ${tooltip(`${balance.toFixedSmart(9)} ${this.symbol}`)}
          style="${styleMap(style)}"
          .value="${balance.toFixedSmart(2)}"
          postfixSymbol="${this.symbol}"
        ></inch-number-animation>
      `;
        }
        return html ` <span ${tooltip(`${balance.toFixedSmart(9)} ${this.symbol}`)}>
      ${balance.toFixedSmart(2)} ${this.symbol}
    </span>`;
    }
    renderLoader() {
        const style = {
            marginLeft: this.endTextAlign ? 'auto' : '',
        };
        return html `<inch-loader-skeleton
      style="${styleMap(style)}"
      .animationDelayMillisecond="${this.skeletonAnimationDelayMillisecond}"
    ></inch-loader-skeleton>`;
    }
};
__decorate([
    property({ type: String, attribute: false }),
    __metadata("design:type", Object)
], TokenBalanceElement.prototype, "value", void 0);
__decorate([
    property({ type: String, attribute: false }),
    __metadata("design:type", String)
], TokenBalanceElement.prototype, "tokenId", void 0);
__decorate([
    property({ type: String, attribute: false }),
    __metadata("design:type", String)
], TokenBalanceElement.prototype, "symbol", void 0);
__decorate([
    property({ type: String, attribute: false }),
    __metadata("design:type", Array)
], TokenBalanceElement.prototype, "chainIds", void 0);
__decorate([
    property({ type: String, attribute: false }),
    __metadata("design:type", String)
], TokenBalanceElement.prototype, "walletAddress", void 0);
__decorate([
    property({ type: Boolean, attribute: true }),
    __metadata("design:type", Object)
], TokenBalanceElement.prototype, "endTextAlign", void 0);
__decorate([
    property({ type: Boolean, attribute: true }),
    __metadata("design:type", Object)
], TokenBalanceElement.prototype, "animateTransition", void 0);
__decorate([
    property({ type: Number, attribute: false }),
    __metadata("design:type", Number)
], TokenBalanceElement.prototype, "skeletonAnimationDelayMillisecond", void 0);
__decorate([
    state(),
    __metadata("design:type", Object)
], TokenBalanceElement.prototype, "isConnectedWallet", void 0);
TokenBalanceElement = __decorate([
    customElement(TokenBalanceElement.tagName)
], TokenBalanceElement);
export { TokenBalanceElement };
//# sourceMappingURL=token-balance.element.js.map